import { convertStartRegResponse,convertFinishRegRequest} from '../../../../lib/yubico-webauthn';
import { Captcha } from '../../../../components/captcha/captcha.model';
import Clipboard from 'clipboard';
import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor($scope,$window,FidoRegistrationDataService,$translate) {
		this.$scope = $scope;
		this.$window=$window;
		this.$translate=$translate;
    	this.FidoRegistrationDataService=FidoRegistrationDataService;
    }

    $onInit() {
		this.displaySpinner = true;
		this.spAlert=null;
		this.registrationSuccessful=false;
		this.registrationFailed=false;
		this.FidoRegistrationDataService.getData({vKey: this.vkey}).$promise
		.then((response) => this.verificationData= response)
		.catch((error) => {
			console.log(error);
			this.registrationFailed=true;
			this.linkExpired=true;
			this.errorMessage=this.$translate.instant('public.hard-token.fido-registration.link-expired');})
		.finally(() => this.displaySpinner = false);

		this.captcha = new Captcha({isVisible: () => true});
		new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
                this.spAlert = new SpAlert('success', 'global.data_copied')
            })
        })
		
	}
	
	startRegistration(){
		const hardTokenId=this.verificationData.hardTokenId;
		const vKey=this.vkey;
		this.FidoRegistrationDataService.startRegistration({vKey,hardTokenId},this.captcha.response).$promise.then((response)=>{
			var credOpts=convertStartRegResponse(response);
			this.$window.navigator.credentials.create(credOpts).then((credentials) => {
				var finishRegRequest = convertFinishRegRequest(credentials,response);
           		this.finishRegistration(finishRegRequest);
           	}).catch((error)=>console.log(error));
		}).catch((error) =>{
			console.log(error);
			this.registerFailedOutput();
			const key = 'hard_tokens.edit.U2F_failed';
            this.spAlert = new SpAlert('danger', key);
        }).finally(() => this.captcha.reset());
	}
	
	finishRegistration(data){
		const hardTokenId=this.verificationData.hardTokenId;
		this.FidoRegistrationDataService.finishRegistration({hardTokenId},data).$promise
		.then(() => {
			this.registerSucceededOutput();
		}).catch((error)=>{
			console.log(error);
			this.registerFailedOutput();
			const key = 'hard_tokens.edit.U2F_failed';
            this.spAlert = new SpAlert('danger', key);
		});
	}
	
	registerFailedOutput() {
		this.registrationFailed=true;
		this.registrationSuccessful=false;
	}
	registerSucceededOutput() {
		this.registrationFailed=false;
		this.registrationSuccessful=true;
	}
}


// WEBPACK FOOTER //
// ./src/portal/states/public/verification/fido-registration/fido-registration.controller.js